import { Pipe, PipeTransform } from '@angular/core';
import { ItemSelectorRowItem } from '../interface';

@Pipe({ name: 'parseWholesaleCurrency' })
export class ParseWholesaleCurrencyPipe implements PipeTransform {
  transform(item: ItemSelectorRowItem): string {
    const pricesForEditions = item?.appPrices?.pricesForContexts?.['wholesale']?.pricesForEditions;
    if (pricesForEditions && Object.keys(pricesForEditions).length > 0) {
      const [firstEditionId] = Object.keys(pricesForEditions);
      const currencies = pricesForEditions[firstEditionId]?.pricesForCurrencies;
      if (currencies && Object.keys(currencies).length > 0) {
        return Object.keys(currencies)[0];
      }
    }
    return 'USD';
  }
}
